module.exports = __webpack_public_path__ + "static/media/camera.1d15d41d.svg";